import { render, staticRenderFns } from "./Commercial.vue?vue&type=template&id=6c6833a1&scoped=true"
import script from "./Commercial.vue?vue&type=script&lang=js"
export * from "./Commercial.vue?vue&type=script&lang=js"
import style0 from "./Commercial.vue?vue&type=style&index=0&id=6c6833a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6833a1",
  null
  
)

export default component.exports